import {
  DisplayConceptRef,
  DisplayUserFollow,
  DisplayUser,
  UPDATE_FOLLOW_ACTION,
  updateFollows,
  UpdateFollowAction,
} from '@/lib/api';

/** Groups followed topics by username for quick lookup in the UI. */
export const followsMap = (
  follows: DisplayUserFollow[] | null
): Map<string, DisplayConceptRef[]> => {
  const followsMap = new Map<string, DisplayConceptRef[]>();
  if (follows != null) {
    follows.forEach((follow) => {
      followsMap.set(follow.username, follow.topics);
    });
  }
  return followsMap;
};

/** Follows a topic for the current user and returns the updated user record. */
export const followTopic = async (topic: DisplayConceptRef): Promise<DisplayUser> => {
  const action: UpdateFollowAction = UPDATE_FOLLOW_ACTION.Follow;
  return updateFollows({
    action,
    topics: [topic.cref],
  });
};

/** Unfollows a topic for the current user and returns the updated user record. */
export const unfollowTopic = async (topic: DisplayConceptRef): Promise<DisplayUser> => {
  const action: UpdateFollowAction = UPDATE_FOLLOW_ACTION.Unfollow;
  return updateFollows({
    action,
    topics: [topic.cref],
  });
};
